import { render, staticRenderFns } from "./NotaInterna.vue?vue&type=template&id=874cccd8&scoped=true&"
import script from "./NotaInterna.vue?vue&type=script&lang=js&"
export * from "./NotaInterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874cccd8",
  null
  
)

export default component.exports